import _defineProperty from "/var/log/nginx/source/CateringManagerX/CateringManager_Html/node_modules/_@babel_runtime-corejs2@7.13.7@@babel/runtime-corejs2/helpers/esm/defineProperty";
import "core-js/modules/es6.number.constructor";

var _name$props$data$prop;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default (_name$props$data$prop = {
  name: 'Url-Upload-Source',
  props: {},
  data: function data() {
    return {
      dialogVisible: false,
      sourceName: '',
      DocPrviewUrl: ''
    };
  }
}, _defineProperty(_name$props$data$prop, "props", {
  folderId: {
    type: String,
    default: ''
  },
  IsPartner: {
    type: Number,
    default: 0
  },
  CourseId: {
    Type: String,
    default: ''
  },
  SchoolCourseTypeId: {
    Type: String,
    default: ''
  }
}), _defineProperty(_name$props$data$prop, "methods", {
  handleClose: function handleClose(done) {},
  createFolderHander: function createFolderHander() {
    this.dialogVisible = true;
  },
  cancelSource: function cancelSource() {
    this.sourceName = '';
    this.DocPrviewUrl = '';
    this.dialogVisible = false;
  },
  addSource: function addSource() {
    var _this = this;

    if (!this.sourceName) {
      this.$message.warning('资源名称不允许为空');
      return false;
    }

    this.$http.post('/api/XOrg/BookMaterial/saveUrlSource', {
      DocPrviewUrl: this.DocPrviewUrl,
      CourseWareName: this.sourceName,
      FolderId: this.folderId,
      CourseId: this.CourseId,
      IsPartner: this.IsPartner,
      SchoolCourseTypeId: this.SchoolCourseTypeId
    }).then(function (rst) {
      if (rst.code > 0) {
        _this.sourceName = '';
        _this.DocPrviewUrl = '';
        _this.dialogVisible = false;

        _this.$message.success(rst.msg);

        _this.$emit('done');
      } else {
        _this.$message.warning(rst.msg);
      }
    });
  }
}), _name$props$data$prop);